module.exports = __webpack_public_path__ + "static/organicdandelion-3814225ae358e0e4d317ed486df527b1.jpeg";